import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { track } from '../../analytics';

export const DeliveryHeader = ({
  zipCode,
  showCheckAvailability,
  setShowCheckAvailability,
  isCartTiles
}) => {

  const handleOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowCheckAvailability(!showCheckAvailability);
    track('click', {
      origin: 'delivery-options',
      eventName: 'check fulfillment availability',
      primaryCategory: 'button submission'
    });
  };

  const availabilityButton = (
    <button
      type="button"
      className="u__default-link fulfillment__header_link"
      role="link"
      onClick={handleOnClick}
    >
      { zipCode }
    </button>
  );

  return (
    <div className="fulfillment__header">
      <span>
        Delivering to { isCartTiles ? zipCode : availabilityButton }
      </span>
    </div>
  );
};

DeliveryHeader.propTypes = {
  zipCode: PropTypes.string.isRequired,
  showCheckAvailability: PropTypes.bool.isRequired,
  setShowCheckAvailability: PropTypes.func.isRequired,
  isCartTiles: PropTypes.bool
};

DeliveryHeader.defaultProps = {
  isCartTiles: false
};
